import { render, staticRenderFns } from "./OversizedCheck.vue?vue&type=template&id=0d327424&scoped=true&"
import script from "./OversizedCheck.vue?vue&type=script&lang=ts&"
export * from "./OversizedCheck.vue?vue&type=script&lang=ts&"
import style0 from "./OversizedCheck.vue?vue&type=style&index=0&id=0d327424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d327424",
  null
  
)

export default component.exports